import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

const IndexPage = ({ data }) => {
  const { file: { childMarkdownRemark: settings } } = data;
  return (
    <div>
      <Helmet
        title={settings.frontmatter.title}
        meta={[
          { name: 'description', content: settings.frontmatter.description }
        ]}
      />
      <div dangerouslySetInnerHTML={{ __html: settings.html }} />
    </div>
  )
}

export default IndexPage

export const indexQuery = graphql`
  query IndexQuery {
    file(relativePath: { eq: "settings/general.md" }) {
      childMarkdownRemark {
        html,
        frontmatter {
          title
          description
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js